<template>
  <div>
    profile
  </div>
</template>

<script>
/**
 * @file       Teachers profile component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {};
</script>

<style lang="scss" scoped></style>
